import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import NewsletterForm from "./NewsletterForm";
import { api, mediaUrl } from "../../lib/api";

export default function Shop() {
  const [teasers, setTeasers] = useState([]);

  useEffect(() => {
    api.getShop().then(setTeasers).catch(() => {});
  }, []);

  const main = teasers.find((t) => t.featured) || teasers[0];
  const rest = teasers.filter((t) => t !== main);

  return (
    <section id="shop" className="relative py-24 md:py-36 bg-wood border-y border-woodborder" data-testid="shop-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Eyebrow index="08" label="COMMERCE" />
          <div className="flex flex-wrap items-center gap-5">
            <h2 className="font-display text-cream text-6xl md:text-8xl tracking-tight leading-[0.85]" data-testid="shop-heading">
              COBAIN <span className="text-outline-tan">CULTURE.</span>
            </h2>
            <span className="font-mono text-[10px] tracking-[0.25em] bg-gold text-obsidian font-bold px-4 py-2 rounded-full" data-testid="shop-coming-soon-badge">
              COMING SOON
            </span>
          </div>
          <p className="mt-5 max-w-lg text-sand font-light">
            The official uniform of the report is in production. Limited numbers, heavyweight everything — built like the brand, not like merch.
          </p>
        </Reveal>

        {main && (
          <Reveal delay={0.12}>
            <div className="mt-14 grid lg:grid-cols-2 gap-6 items-stretch" data-testid="shop-teaser">
              <div className="relative border border-woodborder overflow-hidden spotlight-card min-h-[320px]">
                {main.graphic && (
                  <img src={mediaUrl(main.graphic)} alt={main.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-testid="shop-teaser-graphic" />
                )}
                <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] bg-obsidian/85 backdrop-blur text-gold-bright px-3 py-1.5 border border-gold/30">
                  OFFICIAL DROP
                </span>
              </div>
              <div className="border border-woodborder bg-card/40 p-8 md:p-12 flex flex-col justify-center">
                <h3 className="font-editorial font-extrabold text-cream text-2xl md:text-3xl leading-tight" data-testid="shop-teaser-name">{main.name}</h3>
                {main.description && <p className="mt-4 text-sand font-light leading-relaxed" data-testid="shop-teaser-description">{main.description}</p>}
                {main.price > 0 && (
                  <div className="mt-7 flex items-center gap-4">
                    <span className="font-display text-4xl text-gold-bright blur-md select-none" aria-hidden="true" data-testid="shop-teaser-price">
                      ${Number(main.price).toFixed(0)}
                    </span>
                    <span className="flex items-center gap-2 font-mono text-[9px] tracking-[0.25em] text-clay">
                      <Lock size={11} /> PRICE LOCKED UNTIL DROP
                    </span>
                  </div>
                )}
                <div className="mt-9 max-w-md">
                  <p className="font-mono text-[10px] tracking-[0.25em] text-tan mb-3">GET NOTIFIED WHEN THE DROP LANDS</p>
                  <NewsletterForm source="shop-notify" buttonLabel="NOTIFY ME" testId="shop-notify" />
                </div>
              </div>
            </div>
          </Reveal>
        )}

        {rest.length > 0 && (
          <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="shop-teaser-grid">
            {rest.map((t, i) => (
              <Reveal key={t.id} delay={0.06 * i}>
                <div className="border border-woodborder bg-card/30 overflow-hidden group" data-testid={`shop-teaser-card-${i}`}>
                  {t.graphic && (
                    <div className="relative overflow-hidden">
                      <img src={mediaUrl(t.graphic)} alt={t.name} loading="lazy" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-700" />
                      <span className="absolute top-3 left-3 font-mono text-[9px] tracking-[0.2em] bg-gold text-obsidian font-bold px-2.5 py-1">COMING SOON</span>
                    </div>
                  )}
                  <div className="p-5">
                    <h4 className="font-editorial font-bold text-cream">{t.name}</h4>
                    {t.price > 0 && (
                      <span className="inline-block mt-2 font-display text-xl text-gold-bright blur-sm select-none" aria-hidden="true">${Number(t.price).toFixed(0)}</span>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}

        <Reveal delay={0.2}>
          <p className="mt-10 font-mono text-[10px] tracking-[0.25em] text-clay" data-testid="shop-note">
            SECURE CHECKOUT + FULFILLMENT GO LIVE WITH THE FIRST DROP.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
